export const importAll = (require:any) => require.keys().reduce((acc: any, item: string) => {
    const key: string = <string> item.toString().split('./').pop();
    acc[key] = require(item);
    return acc
}, {});
